@for (menuItem of menu; track menuItem.link) {
  <div class='menu-item'
       [routerLink]='menuItem.link'
       [routerLinkActive]="['is-active']"
       role='button'>
    <img
      [ngSrc]='menuItem.iconUrl'
      alt='Logo'
      width='30'
      height='30'
      class='me-3'
    />
    <div>
      {{ menuItem.label }}
    </div>
  </div>
}
